// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".intro-modal__image--NoaVj{width:140px;height:140px;-o-object-fit:contain;object-fit:contain}.intro-modal__pill--Dj0pa{background-color:#eeecfe}.intro-modal__feature-icon--uDbq3{flex-shrink:0;font-size:22px;line-height:24px;vertical-align:top}.intro-modal__feature-icon--image--PtOdR{color:#21bcff}.intro-modal__feature-icon--minutes--pR75r{color:#ff4b38}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"intro-modal__image": "intro-modal__image--NoaVj",
	"intro-modal__pill": "intro-modal__pill--Dj0pa",
	"intro-modal__feature-icon": "intro-modal__feature-icon--uDbq3",
	"intro-modal__feature-icon--image": "intro-modal__feature-icon--image--PtOdR",
	"intro-modal__feature-icon--minutes": "intro-modal__feature-icon--minutes--pR75r"
};
export default ___CSS_LOADER_EXPORT___;
